import { ROOT_NODE } from "@craftjs/utils";
import React from "react";
import { useLayer } from "./layers";
import { LayerContextProvider } from "./layers/LayerContextProvider";
import { LayerManagerProvider } from "./manager/LayerManagerProvider";

const Layers = ({ id = ROOT_NODE, ...options }) => {
  return (
    <LayerManagerProvider options={options}>
      <LayerContextProvider id={ROOT_NODE} depth={0} />
    </LayerManagerProvider>
  );
};

export { useLayer, Layers };
